export const DefaultPropValues = {
    title: '',
    help: '',
    disabled: false,
    allErrors: false,
};
export function labelObjFromOption(opt) {
    if (typeof opt === 'string') {
        return { en: opt, de: opt };
    }
    return typeof opt.label === 'object' ? opt.label : { en: opt.label, de: opt.label };
}
